export default [
  {
    path: '/more/index',
    name: 'MoreIndex',
    component: () => import('@/views/More/Index.vue'),
  },
  {
    path: '/more/detail',
    name: 'MoreDetail',
    component: () => import('@/views/More/Detail.vue'),
  },
  {
    path: '/more/language',
    name: 'MoreLanguage',
    component: () => import('@/views/More/Language.vue'),
  },
  {
    path: '/more/chatHistory',
    name: 'MoreChatHistory',
    component: () => import('@/views/More/ChatHistory.vue'),
    meta: {
      requiresAuth: true,
    },
  },
];
